<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'devicegroup',
})
</script>
<template>
  <a-card title="组态">
    <template  #extra>
       <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
    </template>
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'DeviceGroupId'">
         {{ AutoData.FindName(datamodel,'DeviceGroupId',record.DeviceGroupId) }}
      </template>
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="auth.edit"  size="small" type="primary" @click="edit(record)">
                <EditOutlined /> 修改
            </a-button>
            <a-button v-if="auth.del"  size="small" type="primary" @click="del(record,index)">
                <DeleteOutlined /> 删除
            </a-button>
          </a-button-group>

      </template>
      <template v-if="column.key === 'editor'">
              <a class=" btn margin-right" target="_blank" :href="'/scene2d?id='+record.ID"><EyeOutlined /> 预览</a >
              <a class="btn"  v-if="auth.edit" target="_blank" :href="'/editor2d?id='+record.ID"><EditOutlined/> 编辑模型</a >
      </template>
    </template>
    </a-table>
    <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  </a-card>
</template>

<script setup lang="ts" name="devicegroup">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'
import {useRouter} from 'vue-router'
import { AutoData } from '@/utils/util'
  const auth:any=api.auth()
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.devicescene.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['ID','Name'])
        columns.value.push({key:'editor',title:'编辑'})
        var role=AutoData.GetFormModel(datamodel.value,['Name'])
        role.Name.required=true
        formRole.value=role
        getList()
      }
    })
  })

const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.devicescene.list({type:0,pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        if(res.state==1){
            dataSource.value=res.data.data
          page.value.total=res.data.records
          page.value.current=res.data.pageIndex
        }
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const edit=(d)=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,d)
  formshow.value=true
}
const editor=(item)=>{
  const router=useRouter()
  router.push({path:'',query:{id:item.ID}})
}
const add=()=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,{ID:0,SceneType:0})
  formshow.value=true
}
const del=(item,i)=>{
  api.devicescene.del(item.ID).then(res=>{
    if(res.state==1){
      dataSource.value.splice(i,1)
    }
  })
}
const submit=(e:any)=>{
  api.devicescene.add(e).then(res=>{
    if(res.state==1){
      formshow.value=false
      getList()
    }
  })
}
</script>
